import { Button, Input, Select, DatePicker, Spin } from 'antd';
import { useState } from 'react';
import { Dynamics } from '@/services/dynamics/dynamics';
import { DynFollowUpData } from '@/services/dynamics/interfaces/relate-to-info.interface';
import { defaultFollowUp } from './CallPanel';
import { LoadingOutlined } from '@ant-design/icons';
const { TextArea } = Input;
const { RangePicker } = DatePicker;
import '../Forms/Forms.scss';

const antIcon = <LoadingOutlined spin />;

interface IProps {
  data: DynFollowUpData;
  contactOptions: any;
  onItemSelected: (data: any) => void;
  onChange: (data: object) => void;
}

const errorText = 'This field is required';

export const FollowUpBlock = ({
  data,
  contactOptions,
  onItemSelected,
  onChange,
}: IProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({
    subject: '',
  });

  const validate = () => {
    let isOk = true;
    const errors = {
      subject: '',
    };
    if (!data.subject) {
      errors.subject = errorText;
      isOk = false;
    }

    setErrors(errors);
    return isOk;
  };

  const sendData = async () => {
    const payload = {
      subject: data.subject,
    };

    if (data.description) {
      Object.assign(payload, { description: data.description });
    }
    if (data.scheduledend) {
      Object.assign(payload, { scheduledend: data.scheduledend });
    }
    if (data.scheduledstart) {
      Object.assign(payload, { scheduledstart: data.scheduledstart });
    }
    if (data.regardingobjectid?.value) {
      Object.assign(payload, {
        'regardingobjectid_contact@odata.bind': `/contacts(${data.regardingobjectid?.value})`,
      });
    }
    await Dynamics.saveNewEntity('task', payload);
    await onChange(defaultFollowUp);
    await setIsLoading(false);
  };

  const submit = () => {
    const canProceed = validate();
    if (canProceed) {
      setIsLoading(true);
      sendData();
    }
  };

  const onDateChange = (...data) => {
    onChange({
      scheduledstart: data[1][0],
      scheduledend: data[1][1],
    });
  };

  const onSubjChange = (e) => {
    setErrors({ subject: '' });
    onChange({ subject: e.target.value });
  };

  return isLoading ? (
    <Spin className="spinner" indicator={antIcon} />
  ) : (
    <div className="note__relate-to form-container">
      <div className="follow-up-heading">Follow up</div>
      <div className="">
        <div className="line">
          Subject
          <Input
            placeholder="Subject"
            data-testid="follow-up-subject"
            value={data.subject}
            onChange={onSubjChange}
          />
          {errors.subject ? (
            <div className="form-error">{errors.subject}</div>
          ) : (
            <></>
          )}
        </div>
        <div className="line">
          Description
          <TextArea
            rows={4}
            onChange={(e) => onChange({ description: e.target.value })}
            className="textarea"
            value={data.description}
          ></TextArea>
        </div>
        <div className="line">
          Regarding
          <Select
            showSearch
            labelInValue
            className="form_follow-up"
            options={contactOptions}
            onSelect={onItemSelected}
            value={data.regardingobjectid}
            placeholder="Please choose an entity name"
            filterOption={(inputValue, option) =>
              option?.label
                ?.toString()
                ?.toUpperCase()
                .indexOf(inputValue?.toUpperCase()) !== -1
            }
          />
        </div>
        <div className="line">
          Start/End
          <RangePicker showTime onChange={onDateChange} />
        </div>

        <div className="button-block" style={{ marginTop: '30px' }}>
          <Button onClick={submit} data-testid="submit-follow-up">
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};
